import React from 'react';
import { useIntegrationSettings } from 'settings/contexts/IntegrationSettingsContext';
import DefaultIntegrationForm from 'settings/forms/DefaultIntegrationForm';

const IntegrationFormRender = () => {
  const { selectedIntegration, currentTab } = useIntegrationSettings();
  if (!selectedIntegration || !currentTab) return null;

  switch (selectedIntegration.slug) {
    case 'SAPSF':
      return currentTab.form();
    default:
      return <DefaultIntegrationForm />;
  }
};

export default IntegrationFormRender;
